var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"future-services text-center"},[_c('div',{staticClass:"future-img"},[_vm._t("cardMedia")],2),_vm._v(" "),_vm._t("cardTitle"),_vm._v(" "),_vm._t("cardBody")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }